"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersService = void 0;
var tslib_1 = require("tslib");
var types_1 = require("@wix/ambassador-members-v1-member/types");
var MembersService = /** @class */ (function () {
    function MembersService(api) {
        this.membersCache = new Map();
        this.api = api;
    }
    MembersService.prototype.queryMembersByName = function (name) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var members, _b, _c, member, e_1;
            var e_2, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!name) {
                            return [2 /*return*/, []];
                        }
                        if ((_a = this.nameQuery) === null || _a === void 0 ? void 0 : _a.startsWith(name)) {
                            return [2 /*return*/, Array.from(this.membersCache.values()).filter(function (member) { var _a, _b; return (_b = (_a = member.profile) === null || _a === void 0 ? void 0 : _a.nickname) === null || _b === void 0 ? void 0 : _b.includes(name); })];
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.queryMembers({
                                query: {
                                    filter: {
                                        'profile.nickname': {
                                            $contains: name,
                                        },
                                    },
                                },
                                fieldsets: [types_1.Set.FULL],
                            })];
                    case 2:
                        members = _e.sent();
                        this.nameQuery = name;
                        try {
                            for (_b = tslib_1.__values(members || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                                member = _c.value;
                                this.membersCache.set(member.id, member);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/, members];
                    case 3:
                        e_1 = _e.sent();
                        this.nameQuery = null;
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MembersService.prototype.getMyMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var myId, member;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        myId = this.api.getCurrentUser().id;
                        if (this.membersCache.has(myId)) {
                            return [2 /*return*/, this.membersCache.get(myId)];
                        }
                        return [4 /*yield*/, this.api.getMyMember()];
                    case 1:
                        member = _a.sent();
                        this.membersCache.set(member.id, member);
                        return [2 /*return*/, member];
                }
            });
        });
    };
    MembersService.prototype.queryMembersByIds = function (ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _members, _ids, members, _b, _c, member;
            var e_3, _d;
            var _this = this;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!ids.length) {
                            return [2 /*return*/, []];
                        }
                        _a = tslib_1.__read(ids.reduce(function (acc, id) {
                            if (_this.membersCache.has(id)) {
                                acc[0].push(_this.membersCache.get(id));
                            }
                            else {
                                acc[1].push(id);
                            }
                            return acc;
                        }, [[], []]), 2), _members = _a[0], _ids = _a[1];
                        if (!_ids.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api.queryMembersByIds(_ids)];
                    case 1:
                        members = _e.sent();
                        try {
                            for (_b = tslib_1.__values(members || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                                member = _c.value;
                                this.membersCache.set(member.id, member);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        return [2 /*return*/, _members.concat(members || [])];
                    case 2: return [2 /*return*/, _members];
                }
            });
        });
    };
    return MembersService;
}());
exports.MembersService = MembersService;
//# sourceMappingURL=MembersService.js.map